module.exports = __webpack_public_path__ + "static/media/spongebob.3177093e.gif";